export default __webpack_public_path__ + "static/screenshot_4-1b8b64fdcd5249ab6c6e9879c9b508fe.png";